import { Area, AreaChart, ResponsiveContainer } from 'recharts'

interface SparklineProps {
  data: number[]
  tone?: 'primary' | 'positive' | 'negative' | 'muted'
  height?: number
}

const TONE_COLORS: Record<NonNullable<SparklineProps['tone']>, string> = {
  primary: 'var(--color-primary)',
  positive: 'var(--color-chart-2)',
  negative: 'var(--color-chart-4)',
  muted: 'var(--muted-foreground)',
}

export function Sparkline({ data, tone = 'primary', height = 32 }: SparklineProps) {
  const series = data.map((v, i) => ({ i, v }))
  const color = TONE_COLORS[tone]
  const id = `spark-${tone}-${Math.random().toString(36).slice(2, 8)}`
  return (
    <div style={{ height }} className="w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={series} margin={{ left: 0, right: 0, top: 2, bottom: 0 }}>
          <defs>
            <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.45} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="v"
            stroke={color}
            strokeWidth={1.5}
            fill={`url(#${id})`}
            dot={false}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  )
}
